import {Inject, Injectable} from '@angular/core';
import {forkJoin, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {map, shareReplay} from "rxjs/operators";
import {GeneralService} from "../general.service";
import {StorageService} from "../storage.service";

@Injectable({
  providedIn: 'root'
})
export class TagRuleService extends GeneralService {
  businessType;
  tagRuleData$: Observable<any>;

  constructor(
      public http: HttpClient,
      private storageService: StorageService,
      @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/tag/tagRule');
    this.businessType = this.storageService.getBusinessTypeItem()
  }

  getCurrentSubSysTagRules(tagRuleGroupId?): Observable<any> {
    this.businessType = this.storageService.getBusinessTypeItem();
    if (!this.tagRuleData$) {
      this.tagRuleData$ = forkJoin([
        this.searchData({businessType: -1, tagRuleGroupId: tagRuleGroupId ? tagRuleGroupId : -1}).pipe(shareReplay(1)),
        this.searchData({businessType: this.businessType, tagRuleGroupId: tagRuleGroupId ? tagRuleGroupId : -1}).pipe(shareReplay(1))
      ]).pipe(
          map(res => {
            const allData = res[0].concat(res[1]);
            allData.sort((a, b) => b.id - a.id);
            return allData
          }),
          shareReplay(1)
      )
    }
    setTimeout(() => {
      this.tagRuleData$ = null;
    }, 10000);
    return this.tagRuleData$;
  }
  getMustDoRuleData(tagRuleGroupId?) {
    return this.getCurrentSubSysTagRules(tagRuleGroupId)
        .pipe(map(res => res.filter(d => d.canMatch === true && d.timeSpan == null)));
  }
  getNotDoRuleData(tagRuleGroupId?) {
    return this.getCurrentSubSysTagRules(tagRuleGroupId)
        .pipe(map(res => res.filter(d => d.canMatch === false && d.timeSpan == null)));
  }
  getSpacingRuleData(tagRuleGroupId?) {
    return this.getCurrentSubSysTagRules(tagRuleGroupId)
        .pipe(map(res => res.filter(d => d.canMatch === true && d.timeSpan != null)));
  }
  getTotalWeightLimitRuleData(tagRuleGroupId?) {
    return this.getCurrentSubSysTagRules(tagRuleGroupId)
        .pipe(map(res => res.filter(d => d.canMatch === true && d.totalWeightLimit != -1)));
  }

}
